module.exports = __webpack_public_path__ + "static/media/paw-expired.5f3c10a4.svg";